import React from 'react';
import { services, IMG_CUT, shopInfo } from '../mock';
import { Button } from './ui/button';
import { Star, Clock } from 'lucide-react';

// Decorative barber pole (SVG)
const BarberPole = ({ className = '' }) => (
  <svg viewBox="0 0 60 180" className={className} aria-hidden="true">
    <ellipse cx="30" cy="14" rx="20" ry="8" fill="#c9a961" />
    <ellipse cx="30" cy="10" rx="20" ry="8" fill="#0a0a0a" stroke="#c9a961" strokeWidth="1.5" />
    <rect x="12" y="16" width="36" height="140" rx="3" fill="#0a0a0a" stroke="#c9a961" strokeWidth="1.5" />
    <g clipPath="url(#pole-clip)">
      <rect x="12" y="16" width="36" height="140" fill="#0a0a0a" />
      {[0, 20, 40, 60, 80, 100, 120, 140].map((y) => (
        <path key={y} d={`M12,${16 + y} L48,${16 + y - 14}`} stroke="#c9a961" strokeWidth="7" />
      ))}
    </g>
    <clipPath id="pole-clip">
      <rect x="12" y="16" width="36" height="140" rx="3" />
    </clipPath>
    <ellipse cx="30" cy="164" rx="20" ry="8" fill="#c9a961" />
    <ellipse cx="30" cy="160" rx="20" ry="8" fill="#0a0a0a" stroke="#c9a961" strokeWidth="1.5" />
  </svg>
);

const Services = () => {
  return (
    <section
      id="services"
      className="relative bg-[#0a0a0a] py-28 md:py-36 border-y border-[#c9a961]/10"
    >
      {/* Gold border frame */}
      <div className="max-w-6xl mx-auto px-6">
        <div className="reveal relative bg-[#0a0a0a] border-2 border-[#c9a961]/70 p-8 md:p-16">
          {/* Title with barber poles */}
          <div className="text-center mb-4">
            <div className="font-bebas text-[#c9a961] text-5xl md:text-6xl tracking-[0.05em]">
              JR BARBER
            </div>
          </div>

          <div className="relative flex items-center justify-center gap-6 mb-12 md:mb-16 max-w-3xl mx-auto">
            <BarberPole className="w-12 md:w-14 h-auto shrink-0" />
            <div className="flex-1 relative">
              <div className="border-t border-[#c9a961]/70" />
              <div className="border-t border-[#c9a961]/70 mt-1.5" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="bg-[#0a0a0a] px-6 font-bebas text-[#c9a961] text-2xl md:text-3xl tracking-[0.3em]">
                  TARIFS DES PRESTATIONS
                </span>
              </div>
            </div>
            <BarberPole className="w-12 md:w-14 h-auto shrink-0" />
          </div>

          {/* Menu list with dotted leaders */}
          <div className="grid md:grid-cols-2 gap-x-14 gap-y-1 max-w-4xl mx-auto">
            {services.map((s) => (
              <div key={s.id} className="group relative py-4 border-b border-[#c9a961]/10 last:border-b-0">
                <div className="flex items-baseline gap-3">
                  <div className="font-bebas text-2xl md:text-[26px] text-[#f5efe4] tracking-wider leading-none whitespace-nowrap">
                    {s.name.toUpperCase()}
                  </div>
                  <div
                    aria-hidden="true"
                    className="flex-1 border-b border-dotted border-[#c9a961]/50 translate-y-[-4px]"
                  />
                  <div className="font-bebas text-2xl md:text-[28px] text-[#c9a961] tracking-wider leading-none whitespace-nowrap">
                    {s.from && <span className="text-sm mr-1">DÈS </span>}
                    {s.price}€
                  </div>
                </div>
                <div className="mt-1.5 flex items-center gap-3 text-[11px] text-[#a8a29e] uppercase tracking-widest">
                  <span className="flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    {s.duration}
                  </span>
                  {s.popular && (
                    <span className="text-[#c9a961] flex items-center gap-1">
                      <Star className="w-3 h-3 fill-[#c9a961]" /> Populaire
                    </span>
                  )}
                  <span className="hidden md:inline text-[#a8a29e]/60 truncate">— {s.description}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-14 text-center">
            <a href={shopInfo.planityUrl} target="_blank" rel="noreferrer">
              <Button className="bg-[#c9a961] hover:bg-[#d9b972] text-[#0a0a0a] font-semibold px-10 py-6 rounded-none font-bebas tracking-[0.25em] text-base">
                RÉSERVER SUR PLANITY
              </Button>
            </a>
            <p className="mt-4 text-xs text-[#a8a29e]">
              Tarifs indicatifs — susceptibles de varier selon la longueur des cheveux.
            </p>
          </div>
        </div>

        {/* Real haircut photo below as showcase */}
        <div className="reveal mt-10 grid md:grid-cols-3 gap-3">
          <div className="md:col-span-2 aspect-[16/9] overflow-hidden border border-[#c9a961]/15">
            <img
              src={IMG_CUT}
              alt="Réalisation JR Barber"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-[900ms]"
            />
          </div>
          <div className="bg-[#141110] border border-[#c9a961]/15 p-8 flex flex-col justify-center">
            <div className="font-bebas text-[#c9a961] text-3xl tracking-widest">
              LE STYLE JR
            </div>
            <p className="mt-3 text-[#c8beab] text-sm leading-relaxed">
              Dégradé net, transition douce, barbe précise. Chaque détail compte pour
              une prestation à la hauteur de vos attentes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
